"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onLeadCreatedEvent = void 0;
const event_names_1 = require("../../event.names");
const ga_event_1 = require("../../helpers/ga-event");
let page = "(not set)";
function onLeadCreatedEvent(eventPage) {
    page = eventPage;
    document.removeEventListener(event_names_1.eventNames.leadCreated, onLeadCreated);
    document.addEventListener(event_names_1.eventNames.leadCreated, onLeadCreated);
}
exports.onLeadCreatedEvent = onLeadCreatedEvent;
function onLeadCreated(event) {
    console.log(event);
    const lead = event.detail.newLead.data;
    console.log(lead);
    // userkey -> GA
    (0, ga_event_1.setUser)(lead.userkey);
    // push conversion
    (0, ga_event_1.customEvent)({}, "gtm.lead_converted");
    (0, ga_event_1.createEvent)({
        eventPage: page,
        eventCategory: "",
        eventSubCategory: "",
        eventAction: "",
        eventLabel: "",
        eventValueType: "LeadId",
        eventValue: lead.id,
        event_name: "conversion",
        sendGA3: false,
    });
}
